import { connect } from 'react-redux';

import LanguagePicker from 'components/nav/shared/LanguagePicker';
import getWeblabs from 'stores/selectors/getWeblabs';

const mapStateToProps = state => ({
  weblabs: getWeblabs(state),
});

export default connect(mapStateToProps)(LanguagePicker);
